/**
 * mco-product-formats.js
 * Theme-side display layer for product format buttons + Free Unreal Vault Access
 * banner + "All Formats Included" trust pill.
 *
 * Scope:
 *   1. Rename "UE4" / "UE5" buttons to "Unreal" in the visible label only — leaves
 *      the underlying option-value (e.g. "UE4") and Shopify variant matching intact,
 *      so we don't have to keep changing the label every time Epic ships a new
 *      engine version, and no product data writes are needed.
 *   2. Reorder format pills to MCO's priority: FBX, OBJ, Unreal, Unity, Blender,
 *      iClone, then any others in their original order.
 *   3. Hide the .va-product-badge "Free Unreal Vault Access" banner unless the
 *      currently-selected Format option = UE4/UE5/Unreal. Re-evaluates on every
 *      variant change so it stays in sync with the picker.
 *   4. Hide the "All Formats Included" trust pill (the .mco-product-trust__item
 *      that contains that text) on any product where the Format option has
 *      multiple values — i.e. the customer has to pick ONE format and isn't
 *      actually getting "all formats". Only the rare master-bundle products
 *      (no Format option, or a single Format value) keep the pill showing.
 *
 * Loaded only on template-product pages via theme.liquid include.
 */
(function () {
  'use strict';

  if ((document.body.className || '').indexOf('template-product') < 0) return;

  var PRIORITY = ['FBX', 'OBJ', 'UNREAL', 'UNITY', 'BLENDER', 'ICLONE'];
  var RENAME = { 'UE4': 'Unreal', 'UE5': 'Unreal' };
  var VAULT_FORMATS = ['UE4', 'UE5'];

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var ran = false;
  function init() {
    if (ran) return;
    ran = true;
    findFormatContainers().forEach(function (container) {
      renameAndReorder(container);
    });
    setupVaultBannerToggle();
    hideAllFormatsBadgeIfMultiFormat();
  }

  function findFormatContainers() {
    var pills = document.querySelectorAll('.mco-variant-picker__options--pills');
    var out = [];
    Array.prototype.forEach.call(pills, function (c) {
      var values = Array.from(c.querySelectorAll('input[type=radio]'))
        .map(function (i) { return (i.value || '').toUpperCase(); });
      var known = ['FBX', 'OBJ', 'UE4', 'UE5', 'UNREAL', 'UNITY', 'BLENDER', 'ICLONE', 'BIP', 'MAYA', 'C4D'];
      if (values.some(function (v) { return known.indexOf(v) >= 0; })) out.push(c);
    });
    return out;
  }

  function renameAndReorder(container) {
    var items = [];
    var inputs = container.querySelectorAll('input[type=radio]');
    Array.prototype.forEach.call(inputs, function (inp) {
      var label = null;
      if (inp.id) label = container.querySelector('label[for="' + cssEscape(inp.id) + '"]');
      if (!label) {
        var n = inp.nextElementSibling;
        while (n && n.tagName !== 'LABEL') n = n.nextElementSibling;
        label = n;
      }
      if (label) items.push({ input: inp, label: label, value: (inp.value || '').trim() });
    });

    items.forEach(function (it) {
      var upper = it.value.toUpperCase();
      var newText = RENAME[upper];
      if (!newText) return;
      var replaced = false;
      Array.prototype.forEach.call(it.label.childNodes, function (node) {
        if (node.nodeType === 3) {
          var txt = node.textContent || '';
          if (txt.trim()) {
            node.textContent = txt.replace(new RegExp(escapeRegex(it.value), 'gi'), newText);
            replaced = true;
          }
        }
      });
      if (!replaced) it.label.textContent = newText;
    });

    function rank(value) {
      var upper = value.toUpperCase();
      var displayKey = (RENAME[upper] || value).toUpperCase();
      var idx = PRIORITY.indexOf(displayKey);
      return idx >= 0 ? idx : 999;
    }

    var sorted = items.slice().sort(function (a, b) {
      var ra = rank(a.value);
      var rb = rank(b.value);
      if (ra !== rb) return ra - rb;
      return items.indexOf(a) - items.indexOf(b);
    });

    sorted.forEach(function (it) {
      container.appendChild(it.input);
      container.appendChild(it.label);
    });
  }

  function setupVaultBannerToggle() {
    var badge = document.querySelector('.va-product-badge');
    if (!badge) return;

    var formatContainers = findFormatContainers();
    if (!formatContainers.length) {
      badge.style.display = 'none';
      return;
    }

    function currentFormat() {
      for (var i = 0; i < formatContainers.length; i++) {
        var checked = formatContainers[i].querySelector('input[type=radio]:checked');
        if (checked) return (checked.value || '').toUpperCase();
      }
      return '';
    }

    function update() {
      var v = currentFormat();
      var show = VAULT_FORMATS.indexOf(v) >= 0;
      badge.style.display = show ? '' : 'none';
    }

    update();

    formatContainers.forEach(function (c) {
      Array.prototype.forEach.call(c.querySelectorAll('input[type=radio]'), function (r) {
        r.addEventListener('change', update);
      });
    });

    document.addEventListener('variant:change', update);
    document.addEventListener('on:variant:change', update);
  }

  function hideAllFormatsBadgeIfMultiFormat() {
    var formatContainers = findFormatContainers();
    var hasMultiple = false;
    for (var i = 0; i < formatContainers.length; i++) {
      var inputs = formatContainers[i].querySelectorAll('input[type=radio]');
      if (inputs.length > 1) { hasMultiple = true; break; }
    }
    if (!hasMultiple) return;

    var items = document.querySelectorAll('.mco-product-trust__item');
    Array.prototype.forEach.call(items, function (item) {
      if (/all\s+formats\s+included/i.test(item.textContent || '')) {
        item.style.display = 'none';
      }
    });
  }

  function escapeRegex(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  function cssEscape(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return s.replace(/"/g, '\\"');
  }
})();
